import "./BrandStory.module.css";
import Navigation from "@/reusable_sections/Header";
import Journey from "./sections/Journey";
import Craftsmanship from "./sections/Craftsmanship";
import Milestones from "./sections/Milestones";
import Footer from "@/reusable_sections/Footer";
export default function BrandStoryPage() {
  return <div>
      <Navigation />
      <Journey />
      <Craftsmanship />
      <Milestones />
      <Footer />
    </div>;
}